//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';


export default {
    state: {
        dispatchStageList: [],
        searchRequest: null,
      },

      mutations: {
        updateDispatchStageList(state, list) {
          state.dispatchStageList = list;
        },
        updateSearchDispatchStageListRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async loadDispatchStageList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

          // if (requestToSend.apptDate.startDate)
          // {
          //   requestToSend.apptDate.startDate = dateFormat.getLocalDate(requestToSend.apptDate.startDate);
          // }

          // if (requestToSend.apptDate.endDate)
          // {
          //   requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.endDate);
          // }
          // else
          // {
          //   requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.startDate);
          // }

          // if (requestToSend.cargoCutOff.startDate)
          // {
          //   requestToSend.cargoCutOff.startDate = dateFormat.getLocalDate(requestToSend.cargoCutOff.startDate);
          // }

          // if (requestToSend.cargoCutOff.endDate)
          // {
          //   requestToSend.cargoCutOff.endDate = dateFormat.getLocalDateEnd(requestToSend.cargoCutOff.endDate);
          // }
          // else
          // {
          //   requestToSend.cargoCutOff.endDate = dateFormat.getLocalDateEnd(requestToSend.cargoCutOff.startDate);
          // }

          const st = performance.now();
          //const result = await api.post('/api/w/stc/dispatchstagelist', requestToSend);
          const result = await newAPIPost('/api/w/stc/dispatchstagelist', requestToSend);
          commit('updateSearchDispatchStageListRequest', fallbackRequest);
          console.log("dispatchStageList: " + requestToSend);
          console.log(result);
          return commit('updateDispatchStageList', result);
            
                },
      },

      getters: {
        getDispatchStageList: state => state.dispatchStageList,
      },




}